"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAGIC_CONTEXT_ID = exports.MAGIC_PROGRAM_ID = exports.DELEGATION_PROGRAM_ID = void 0;
exports.DELEGATION_PROGRAM_ID = "DELeGGvXpWV2fqJUhqcF5ZSYMS4JTLjteaAMARRSaeSh";
exports.MAGIC_PROGRAM_ID = "Magic11111111111111111111111111111111111111";
exports.MAGIC_CONTEXT_ID = "MagicContext1111111111111111111111111111111";
//# sourceMappingURL=constants.js.map